import { Button, ButtonProps } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone';
import useProfileContactButton from '@components/Profile/hooks/useProfileContactButton';
import { useProfilePageBi } from '@components/Hooks/useProfilePageBi';
import s from './ContactButton.module.scss';

export const dataHooks = {
  contactButton: 'profile-contact-button',
  contactButtonAgency: 'profile-contact-button-agency',
  contactButtonMp: 'profile-contact-button-mp',
  emailContactButton: 'profile-contact-button-direct-email',
};

interface Props {
  onContactClicked?: () => void;
  buttonProps?: ButtonProps;
}

const ContactButton = ({ onContactClicked, buttonProps = {} }: Props) => {
  const { t } = useTranslation();
  const {
    isMyProfile,
    havePageType,
    shouldRenderContactButtonWithoutPageType,
    shouldUseMailToButton,
    partnerEmail,
    shouldUseAgencyContactForm,
  } = useProfileContactButton();

  if (isMyProfile) {
    return null;
  }

  if (!havePageType && !shouldRenderContactButtonWithoutPageType) {
    return null;
  }

  if (shouldUseMailToButton) {
    return partnerEmail ? (
      <ContactButtonWithEmail email={partnerEmail} buttonProps={buttonProps} />
    ) : null;
  }

  const dataHook = shouldUseAgencyContactForm
    ? dataHooks.contactButtonAgency
    : dataHooks.contactButtonMp;

  return (
    <Button
      className={s.contactButton}
      dataHook={dataHook}
      onClick={onContactClicked}
      size="large"
      skin="dark"
      {...buttonProps}
    >
      {t('marketplace-contact-button')}
    </Button>
  );
};

const ContactButtonWithEmail = ({
  email,
  buttonProps = {},
}: {
  email?: string;
  buttonProps?: Pick<ButtonProps, 'skin' | 'size' | 'dataHook' | 'className'>;
}) => {
  const { t } = useTranslation();
  const { logProfilePageClick } = useProfilePageBi();

  if (email) {
    return (
      <Button
        className={s.contactButton}
        dataHook={dataHooks.emailContactButton}
        size="large"
        skin="dark"
        as="a"
        onClick={() => logProfilePageClick('connect')}
        href={`mailto:${email}`}
        {...buttonProps}
      >
        {t('marketplace-contact-button')}
      </Button>
    );
  }

  return null;
};

export default ContactButton;
